
import request from '@/utils/request'
// 登陆
export function login(user_name, user_pwd) {
  return request({
    url: '/login/userlogin',
    method: 'post',
    data: {
      user_name,
      user_pwd
    }
  })
}
// 获取用户信息
export function getInfo() {
  return request({
    url: '/login/userinfo',
    method: 'post',
  })
}
// 退出
export function logout() {
  return request({
    url: '/login/logout',
    method: 'post'
  })
}
// 订单列表
export function orderList(data) {
  return request({
    url:'/order/orderlist',
    method:'post',
    data
  })
}

// 订单列表
export function orderdellist(data) {
  return request({
    url:'/order/orderdellist',
    method:'post',
    data
  })
}

// 获取金额信息
export function getsetmoeny(data) {
  return request({
    url:'/setup/getsetmoeny',
    method:'post',
    data
  })
}
// 设置金额
export function setmoeny(data) {
  return request({
    url:'/setup/setmoeny',
    method:'post',
    data
  })
}
// 修改密码
export function passedit(data) {
  return request({
    url: '/setup/passedit',
    method: 'post',
    data
  })
}

// 统计列表
export function censustotal(data) {
  return request({
    url:'/census/censustotal',
    method:'post',
    data
  })
}
// 中奖订单列表
export function orderlottery(data) {
  return request({
    url:'/order/orderlottery',
    method:'post',
    data
  })
}
// 中奖订单兑换
export function orderexchange(data) {
  return request({
    url:'/order/orderexchange',
    method:'post',
    data
  })
}
// 只获取玩法 没有场次
export function settinglist(data) {
  return request({
    url:'/home/settinglist',
    method:'post',
    data
  })
}
// 根据玩法获取场次
export function settingsession(data) {
  return request({
    url:'/home/settingsession',
    method:'POST',
    data
  })
}
// 获取whatsapp区号
export function country(data) {
  return request({
    url:'/home/country',
    method:'post',
    data
  })
}
// 创建订单
export function addorder(data) {
  return request({
    url:'/home/addorder',
    method:'post',
    data
  })
}
// 根据玩法 获取玩法设置信息
export function settinginfo(data) {
  return request({
    url:'/home/settinginfo',
    method:'post',
    data
  })
}

// 根据订单号查询订单
export function ordernoselect(data) {
  return request({
    url:'home/ordernoselect',
    method:'post',
   data
  })
}

// 根据订单号打印查询
export function orderprint(data) {
  return request({
    url:'order/orderprint',
    method:'post',
    data
  })
}

// 根据订单号打印查询
export function orderdel(data) {
  return request({
    url:'order/orderdel',
    method:'post',
    data
  })
}
// 根据订单号打印查询
export function getpageContent(data) {
  return request({
    url:'system/pagecontentop',
    method:'post',
    data
  })
}

// 版本升级
export function versionUpgrade(sendmsg) {
	return request({
		url: 'system/appversion',
		method: 'post',
		sendmsg
	})
}

// 创建订单
export function SignOrder(data) {
  return request({
    url:'/home/signorder',
    method:'post',
    data
  })
}



// 统计列表
export function censusnewprint(data) {
  return request({
    url:'/censusnew/print',
    method:'post',
    data
  })
}
// 统计列表
export function censusnewprintshare(data) {
  return request({
    url:'/censusnew/printshare',
    method:'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/urlApi.js